import 'core-js/stable';
import ReactDOM from 'react-dom/client';
import { App } from './App';

// Export a function that initializes the React app
// This makes it consumable as a UMD module
export default function initializeApp(containerId: string) {
  const container = document.getElementById(containerId);
  if (!container) return;
  const root = ReactDOM.createRoot(container);
  root.render(<App/>);
}

// Auto-initialize if in browser environment and root element exists
if (typeof window !== 'undefined') {
  const rootElementId = 'root';
  const rootElement = document.getElementById(rootElementId);
  if (rootElement) {
    initializeApp(rootElementId);
  }
}
